"use client";
import React, { useState } from "react";
import { EzFormData } from "@/customTypes";
import { submitEzForm } from "@/actions/serverActions";
import { useForm } from "react-hook-form";
import { AnimatePresence, motion } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha";
import { CAPTCHA_KEY } from "@/env";

const ContactForm = () => {
  const { register, handleSubmit, reset } = useForm();
  const [inProgress, setInProgress] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [captchaSuccess, setCaptchaSuccess] = useState(false);

  const submitMessage = async (data: any) => {
    const { name, email, message } = data;

    if (!name || !email || !message) return;

    setInProgress(true);

    const newContactData: EzFormData = {
      formName: "Contact Form",
      formData: {
        name,
        email,
        message,
      },
    };

    let response = await submitEzForm(newContactData);
    if (response) {
      reset();
      setInProgress(false);
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
      }, 5000);
    }
  };

  return (
    <div className="contact-form w-full md:w-1/2 md:pl-14">
      <AnimatePresence>
        {isSuccess && (
          <motion.div
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 0 }}
            className="success-message mb-6"
          >
            <div
              className="rounded-b border-t-4 border-teal-500 bg-teal-100 px-4 py-3 text-teal-900 shadow-md"
              role="alert"
            >
              <div className="flex">
                <div className="py-1">
                  <svg
                    className="mr-4 h-6 w-6 fill-current text-teal-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"></path>
                  </svg>
                </div>
                <div>
                  <p className="font-bold">
                    Your information has been submitted successfully.
                  </p>
                  <p className="text-sm">Our team will respond shortly.</p>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <form onSubmit={handleSubmit(submitMessage)} id="contact-form">
        <div className="mb-6">
          <label className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            required
            {...register("name")}
          />
        </div>
        <div className="mb-6">
          <label className="form-label">
            Email <span>*</span>
          </label>
          <input
            type="email"
            className="form-control"
            id="inputEmail"
            aria-describedby="emailHelp"
            required
            {...register("email")}
          />
        </div>
        <div className="mb-6">
          <label className="form-label">
            Message <span>*</span>
          </label>
          <textarea
            cols={30}
            rows={10}
            required
            {...register("message")}
          ></textarea>
        </div>
        <ReCAPTCHA
          sitekey={CAPTCHA_KEY}
          onChange={(value) => {
            if (value) setCaptchaSuccess(true);
          }}
        />

        <button
          type={!!inProgress ? "button" : "submit"}
          className={`btn-submit ${
            !captchaSuccess &&
            "pointer-events-none cursor-not-allowed opacity-50"
          }`}
          disabled={!!inProgress ? true : false}
        >
          {!!inProgress ? "Please Wait..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
